export default "__VITE_ASSET__CtgUtIgy__"